import React from 'react';
import { Header } from './page-header.styled';
import BackButton from 'app/private/containers/users/components/back-button';
interface IPageHeaderProps {
    leftElement?: React.ReactNode;
}

const PageHeader: React.FC<IPageHeaderProps> = ({ leftElement }) => {
    return (
        <Header>
            <BackButton />
            {leftElement}
        </Header>
    );
};

export default PageHeader;
